export let AUTH_TYPE = /*#__PURE__*/function (AUTH_TYPE) {
  AUTH_TYPE["ANONYMOUS"] = "ANONYMOUS";
  AUTH_TYPE["ARL"] = "ARL";
  AUTH_TYPE["CREDENTIALS"] = "CREDENTIALS";
  AUTH_TYPE["LOGOUT"] = "LOGOUT";
  AUTH_TYPE["PARTNER"] = "PARTNER";
  AUTH_TYPE["RENEW"] = "RENEW";
  return AUTH_TYPE;
}({});

// Doc: https://deezer.jira.com/wiki/spaces/GRAPHQL/pages/1446281276/Authentication+service+routes
export const AUTH_PATH = {
  ANONYMOUS: 'login/anonymous',
  ARL: 'login/arl',
  CREDENTIALS: 'login/credentials',
  LOGOUT: 'logout',
  PARTNER: 'login/partner-access-token',
  RENEW: 'login/renew'
};
export let QUERY_PARAMS_TYPE = /*#__PURE__*/function (QUERY_PARAMS_TYPE) {
  QUERY_PARAMS_TYPE["COOKIE"] = "c";
  QUERY_PARAMS_TYPE["PAYLOAD"] = "p";
  return QUERY_PARAMS_TYPE;
}({});

// Mixins in TypeScript requires to use a tuple of `any`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
//# sourceMappingURL=types.js.map